module.exports = __webpack_public_path__ + "components/country-flag/static/gb-nir-dff8a92e3db3989eb0ce828fb349135d.svg";